const API_URL = "https://api.prijslijst.info";
export default API_URL;
export const EMPTY_PRICES_CROSSED = false;

export const S3_BUCKET = "images-prijslijst-info";
export const S3_UPLOAD_BUCKET = "prijslijst-upload";
export const REGION = "eu-central-1";
export const AWS_ACCESS_KEY_ID = "AKIA6L2ISDD6WDTMVRYU";
export const AWS_SECRET_ACCESS_KEY = "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";
export const WEBSOCKET_URL = "wss://8k632v48gk.execute-api.eu-central-1.amazonaws.com/prod";
export const PUBLIC_URL = "https://shop.prijslijst.info";
